<template>
    <div class="d-flex justify-content-start mb-4">
        <core-basic-drop-down
            class="input-group px-0 col-sm-1"
            :items="calcTypes"
            :selection.sync="selectedCalcType"
            noLabel
            :simple-value="false"
            :labelAttribute="labelAttribute"
        ></core-basic-drop-down>
        <div class="col-sm-2 pl-4 pr-4" v-if="selectedSymbol === 1 || selectedSymbol === '1'">
            <input
                class="input-group"
                type="number"
                v-model="initialAmount"
            />
        </div>
        <div class="col-sm-2 pl-4 pr-4" v-else>
            <core-money-input
                class="input-group"
                :amount.sync="initialAmount"
            />
        </div>
        <core-basic-drop-down
            class="input-group px-0 col-sm-1"
            :items="symbols"
            :selection.sync="selectedSymbol"
            noLabel
        ></core-basic-drop-down>
    </div>
</template>

<script>
export default {
  data () {
    return {
      selectedCalcType: this.type,
      initialAmount: this.amount,
      calcTypes: this.$store.getters.calcTypes,
      symbols: [{'id': 0, 'name': 'EUR'}, {id: 1, 'name': '%'}],
      selectedSymbol: this.isPercent
    }
  },
  props: {
    type: {
      default: 0,
      type: String | Number,
      required: false
    },
    isPercent: {
      default: 0,
      type: String | Number,
      required: false
    },
    amount: {
      default: 0,
      type: String | Number,
      required: false
    },
    section: {
      default: null,
      type: String,
      required: false
    }
  },
  computed: {
    labelAttribute () {
      return 'name_' + this.$i18n.locale.toUpperCase()
    }
  },
  created () {
    switch (this.section) {
      case 'ages':
      case 'offers':
      case 'pax':
        let offerTypes = [
          'ADDITION',
          'DISCOUNT'
        ]
        this.calcTypes = []
        offerTypes.forEach((offerType) => {
          let found = this.$_.find(this.$store.getters.calcTypes, {'code': offerType})
          if (found) {
            this.calcTypes.push(found)
          }
        })
        break

      default:
        this.calcTypes = this.$store.getters.calcTypes
        break
    }
  },
  watch: {
    selectedCalcType (val) {
      this.$emit('update:type', val)
    },
    selectedSymbol (val) {
      this.$emit('update:isPercent', val)
    },
    initialAmount (val) {
      this.$emit('update:amount', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/element/CalcType.vue